/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
//actions
import { displayModal } from '@insticator/insticator-ui'; // iui-utils
import { deleteUser } from 'state/actions/accountState/account_data';
// component
import DeleteUser from 'pages/dashboard/account/users/deleteuser/deleteuser';



/* ========== ~~~~~~~~~~ ACCOUNT DELETE USER : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({}) => ({
});

// map actions
const mapDispatchToProps = dispatch => ({
    deleteUser: (userUUID, index) => dispatch(deleteUser(userUUID, index)),
    displayModal: bool => dispatch(displayModal(bool))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DeleteUser);
